<div class="main">

    <div class="section">
        <div class="header">
            <span>Create {{noteType}} Note</span>
            <button mat-icon-button [mat-dialog-close]="true">
                <mat-icon class="close-icon">close</mat-icon>
            </button>
        </div>
        <div class="body">
            <div class="detailsDiv">
                <div class="subHeader">
                    Vendor Details
                </div>
                <div class="containerSection">
                    <div class="inputContainer">
                        <div class="label">
                            Vendor name
                        </div>
                        <div class="input">
                            <!-- <mat-select class="matSelect" style="color: #fff;">
                                <mat-option style="width: 400px;">

                                </mat-option>
                            </mat-select> -->
                            <input type="text" [(ngModel)]="shipperInfo">
                        </div>
                    </div>

                </div>
            </div>
            <div class="detailsDiv">
                <div class="subHeader">
                    Debit Details
                </div>
                <div class="containerSection">
                    <!-- <div class="inputContainer">
                        <div class="label">
                            Debit Note
                        </div>
                        <div class="input">
                            <input type="text">
                        </div>
                    </div> -->
                    <div class="inputContainer">
                        <div class="label">
                            Reference No
                        </div>
                        <div class="input">
                            <input type="text" [(ngModel)]="referenceNo">
                        </div>
                    </div>
                    <div class="inputContainer">
                        <div class="label">
                            Date
                        </div>
                        <div class="input">
                            <input type="text" name="expiryDate" [matDatepicker]="picker" (click)="picker.open()"
                                [(ngModel)]="note_date" />
                            <mat-datepicker #picker (closed)="setDateTime(note_date)"></mat-datepicker>
                        </div>
                    </div>
                    <div class="inputContainer">
                        <div class="label">
                            Vendor Bill
                        </div>
                        <div class="input">
                            <!-- <mat-select class="matSelect" style="color: #fff;" [(ngModel)]="selectedBill">
                                <mat-option style="width: 400px;" [value]="selectedBill">
                                    hello
                                </mat-option>
                            </mat-select> -->
                            <input type="text" [(ngModel)]="vendorBill">
                        </div>
                    </div>
                </div>
            </div>
            <div class="detailsDiv">
                <div class="subHeader">
                    Other Details
                </div>
                <div class="containerSection">
                    <div class="inputContainer">
                        <div class="label">
                            Subject
                        </div>
                        <div class="input">
                            <input type="text" [(ngModel)]="narration">
                        </div>
                    </div>
                </div>
            </div>
            <div class="detailsDiv">
                <div class="subHeader">
                    Items
                </div>
                <div class="containerSection" style="flex-direction: column;
    width: 100%;">
                    <div class="headers">
                        <div class="labelHead">Select Service</div>
                        <div class="labelHead">Quantity</div>
                        <div class="labelHead">Rate</div>
                        <div class="labelHead">Amount</div>
                        <div class="labelHead">Action</div>
                    </div>
                    <div class="row">
                        <div class="items" *ngFor="let charge of charges; let i = index;">
                            <div class="inputContainer" style="width: 150px">
                                <div class="input" style="width: 150px">
                                    <mat-select class="matSelect" style="color: #fff;" [(ngModel)]="charge.service">
                                        <mat-option style="width: 400px;" *ngFor="let item of chargeList"
                                            [value]="item">
                                            {{item}}
                                        </mat-option>
                                    </mat-select>
                                </div>
                            </div>
                            <div class="inputContainer" style="width: 150px">
                                <div class="input" style="width: 150px">
                                    <input type="number" [(ngModel)]="charge.quantity" (keyup)="calculateTotal(i)">
                                </div>
                            </div>
                            <div class="inputContainer" style="width: 150px">
                                <div class="input" style="width: 150px">
                                    <input type="number" [(ngModel)]="charge.rate" (keyup)="calculateTotal(i)">
                                </div>
                            </div>
                            <div class="inputContainer" style="width: 150px">
                                <div class="input" style="width: 150px">
                                    <input type="number" [disabled]="true" [(ngModel)]="charge.amount">
                                </div>
                            </div>
                            <div class="inputContainer" style="width: 150px">
                                <div class="icon" (click)="charges.length == 1 ? '' : removeCharge(i);">
                                    <i class="material-icons">
                                        delete
                                    </i>
                                </div>
                            </div>
                        </div>
                        <div class="newButton" style="width: 88px;height: 24px;" (click)="addCharge()">
                            <div class="label">
                                Add Item
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="detailsDiv" style="display: flex;flex-direction: row-reverse;">
                <div class="totalSection">
                    <div class="eachRow">
                        <div class="cell">
                            <div class="cellLabel">
                                Sub Total
                            </div>
                        </div>
                        <div class="cell">
                            <div class="cellLabel">
                                {{subTotalAmount}}
                            </div>
                        </div>
                    </div>
                    <div class="eachRow">
                        <div class="cell">
                            <div class="cellLabel">
                                Discount
                            </div>
                        </div>
                        <div class="cell">
                            <div class="input">
                                <mat-select class="matSelect" style="color: #fff;" [(ngModel)]="selectedDiscountType"
                                    (selectionChange)="calculateDiscount()">
                                    <mat-option style="width: 400px;" *ngFor="let type of discountTypes" [value]="type">
                                        {{type}}
                                    </mat-option>
                                </mat-select>
                            </div>
                        </div>
                        <div class="cell">
                            <div class="input">
                                <input type="text" [(ngModel)]="discountValue" (keyup)="calculateDiscount()">
                            </div>
                        </div>
                    </div>
                    <div class="eachRow">
                        <div class="cell">
                            <div class="cellLabel">
                                Adjustment
                            </div>
                        </div>
                        <div class="cell">
                            <div class="input">
                                <input type="number" [(ngModel)]="adjustmentAmount" (keyup)="calculateAdjustedAmount()">
                            </div>
                        </div>
                        <div class="cell">
                            <div class="cellLabel">

                            </div>
                        </div>
                    </div>
                    <div class="eachRow">
                        <div class="cell">
                            <div class="cellLabel">
                                Total
                            </div>
                        </div>
                        <div class="cell">
                            <div class="cellLabel">
                                {{totalAmount}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="detailsDiv">
                <div class="subHeader">
                    Remarks
                </div>
                <div class="containerSection">
                    <div class="inputContainer">
                        <div class="label">
                            Remarks
                        </div>
                        <div class="input">
                            <input type="text" [(ngModel)]="remarks">
                        </div>
                    </div>
                </div>
            </div>
            <div class="detailsDiv" style="display: flex;flex-direction: row-reverse;">
                <div class="newButton" (click)="noteType === 'Debit' ? createDebitNote(): createCreditNote()">
                    <div class="label">
                        Submit
                    </div>
                </div>
            </div>
        </div>


    </div>
</div>